import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { resources } from '~/src/locales'

export const languageDefault = 'ja'
export const kaihoAdminLan = 'kaihoAdminLan'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: resources,
    // lng: languageDefault,
    fallbackLng: languageDefault,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: kaihoAdminLan,
      caches: ['localStorage'],
    },
  })

export { i18n }
